import { useAllProducts } from '@/hooks/Product';

export const useAllIndividualShipEligible = () => {
  const { products, isLoading, isFetching } = useAllProducts();

  const allIndividualShipEligible =
    products?.every((product) => product?.individual_ship_eligible ?? false) ??
    false;

  return [allIndividualShipEligible, { isLoading, isFetching }] as const;
};
